import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container, Row, Carousel, CarouselItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// Own constants/actions/components
import { getFiltersAction } from 'services/actions/filters';
import { results, resData } from 'services/selectors/filters';
import CardInfo from 'components/cards';
import LoaderCP from 'components/loader';

const FilterExperiencesContainer = () => {
  const dispatch = useDispatch();
  const resApi = useSelector(results);
  const resultsData = useSelector(resData);
  const [textsearch, setTextsearch] = useState(false);
  const [categorie, setCategorie] = useState('');
  const [totalCategories, setTotalCategories] = useState(0);
  const [showAll, setShowAll] = useState(true);
  const [filterExperiencies, setFilterExperiencies] = useState([]);
  const [activeButton, setActiveButton] = useState(null);
  const classesButton = 'btn btn-outline btn-outline-orange btn-filter matches-columns d-lg-block ';

  useEffect(() => {
    dispatch(getFiltersAction());
  }, [filterExperiencies]);

  // const handleActiveButton = (event) => {
  //   /* Actived class 'active' button */
  //   const elem = event.target;
  //   const elements = document.querySelectorAll('.btn-filter');
  //   Array.from(elements).map((b) => {
  //     return b.classList.remove('active');
  //   });
  //   elem.classList.add('active');

  //   /* Create new filter array categoryID by experencie */
  //   const arrayExp = resultsData.results.experiences;
  //   const numCategories = [];
  //   const counts = {};

  //   arrayExp.map((r) => {
  //     numCategories.push(r.category.id);
  //     return numCategories;
  //   });
  //   /* Ordering by categorie number and totals */
  //   numCategories.forEach((x) => {
  //     counts[x] = (counts[x] || 0) + 1;
  //   });

  //   /* Get id for filter categorie and hide others options */
  //   const idSelect = Number(elem.id);
  //   const showOptions = elem.dataset.show;
  //   setCategorie(elem.value);
  //   setTotalCategories(counts[idSelect] ? counts[idSelect] : 0);
  //   const categoriesAll = document.querySelectorAll('.cate-all');
  //   const categoriesAllSeleted = document.querySelectorAll(`.cate-${idSelect}`);
  //   Array.from(categoriesAll).map((ctAll) => {
  //     return ctAll.classList.add('d-none');
  //   });
  //   Array.from(categoriesAllSeleted).map((ctSelectd) => {
  //     return ctSelectd.classList.remove('d-none');
  //   });

  //   /* Show/hidden carousel controls while expereiences exist */
  //   if (Array.from(categoriesAllSeleted).length > 0) {
  //     document.querySelector('.carousel.filter-carousel').classList.add('with-controls');
  //   } else {
  //     document.querySelector('.carousel.filter-carousel').classList.remove('with-controls');
  //   }

  //   if (showOptions !== true) {
  //     setTextsearch(true);
  //   }
  //   if (showOptions === 'true') {
  //     Array.from(categoriesAll).map((ctAll) => {
  //       return ctAll.classList.remove('d-none');
  //     });
  //     setTextsearch(false);
  //     document.querySelector('.carousel.filter-carousel').classList.add('with-controls');
  //   }
  // };

  const handleActiveButtonMobile = (event) => {
    /* Actived class 'active' button */
    const elem = event.target;
    setActiveButton(elem.name);

    /* Create new filter array categoryID by experencie */
    const arrayExp = resultsData.results.experiences;
    const numCategories = [];
    const counts = {};
    const idSelect = Number(elem.id);

    arrayExp.map((r) => {
      numCategories.push(r.category.id);
      return numCategories;
    });
    numCategories.forEach((x) => {
      counts[x] = (counts[x] || 0) + 1;
    });

    setCategorie(elem.name);
    setTotalCategories(counts[idSelect] ? counts[idSelect] : 0);

    /* Show / hidden experiencies filtered by 'name' */
    const dataOriginal = resultsData.results.experiences;

    if (elem.name === 'Ver todas') {
      setShowAll(true);
      setTextsearch(false);
    } else {
      setShowAll(false);
      setFilterExperiencies(dataOriginal.filter((exp) => exp.category.name === elem.name));
      setTextsearch(true);
    }
  };

  const renderBody = () => {
    return (
      <Container id="experiencias">
        <Row className="py-15 py-md-60 pb-0 pb-md-60">
          {/* <Col lg={12}>
            <h2 className="text-midnight-blue">Descubre las Experiencias que tenemos para ti</h2>
          </Col> */}
          {/* <Col lg={2} className="py-15 d-none d-lg-block d-xl-block"> */}
          {/* <h4 className="text-tangaroa ft-20">Filtrar por:</h4> */}
          {/* {
              resultsData.results.categories.map((c) => {
                return (
                  <button
                    id={c.id}
                    key={c.id}
                    value={c.name}
                    type="button"
                    className="btn btn-outline btn-outline-orange btn-filter
                    matches-columns d-lg-block"
                    onClick={handleActiveButton}
                    data-show={c.showAllOptions}>
                    {c.name}
                  </button>
                );
              })
            } */}
          {/* </Col> */}
          <Col lg={2} className="py-15 paginator d-lg-none d-xl-none">
            {/* <h4 className="text-tangaroa ft-20">Filtrar por:</h4> */}
            {
              resultsData.results.categories.map((c) => {
                return (
                  <button
                    id={c.id}
                    key={c.id}
                    value={c.name}
                    name={c.name}
                    type="button"
                    className={`${classesButton} ${activeButton === c.name ? 'active' : ''}`}
                    onClick={handleActiveButtonMobile}
                    data-show={c.showAllOptions}>
                    {c.name}
                  </button>
                );
              })
            }
          </Col>
          <Col lg={12} className="py-15">
            <h4 className="text-tangaroa ft-16">
              { textsearch
                ? `${totalCategories} ${totalCategories === 1 ? 'resultado' : 'resultados'} para '${categorie}'` : '' }
            </h4>
            <Row className="d-none d-lg-flex d-xl-flex">
              {
                resultsData.results.experiences.map((e) => {
                  return (
                    <Col lg={3} key={e.id} className={`cate-${e.category.id} cate-all`}>
                      <Link to={`${e.pathName}/${e.id}`} className="not-link">
                        <CardInfo
                          key={e.id}
                          recommend
                          stock={e.stock}
                          image={e.imageUrl}
                          title={e.title}
                          place={e.location}
                          points={e.cost}
                          pointsWithDisscount={e.costWithDisscount}
                          textlabel={e.category.name} />
                      </Link>
                    </Col>
                  );
                })
              }
            </Row>
            <div className="d-lg-none d-xl-none">
              {
                showAll ? (
                  <Carousel
                    interval={null}
                    indicators={false}
                    className={`filter-carousel mb-0 mb-md-30 ${resultsData.results.experiences.length > 0 ? 'with-controls' : ''}`}>
                    {
                      resultsData.results.experiences.map((e) => {
                        return (
                          <CarouselItem key={e.id} className={`cate-${e.category.id} cate-all`}>
                            <Link to={`${e.pathName}/${e.id}`} className="not-link">
                              <CardInfo
                                key={e.id}
                                recommend
                                stock={e.stock}
                                image={e.imageUrl}
                                title={e.title}
                                place={e.location}
                                points={e.cost}
                                pointsWithDisscount={e.costWithDisscount}
                                textlabel={e.category.name} />
                            </Link>
                          </CarouselItem>
                        );
                      })
                    }
                  </Carousel>
                ) : ''
              }
              <Carousel
                interval={null}
                indicators={false}
                className={`filter-carousel ${filterExperiencies.length > 0 ? 'with-controls' : ''}`}>
                {
                  filterExperiencies.map((e) => {
                    return (
                      <CarouselItem key={e.id} className={`cate-${e.category.id} cate-all`}>
                        <Link to={`${e.pathName}/${e.id}`} className="not-link">
                          <CardInfo
                            key={e.id}
                            recommend
                            stock={e.stock}
                            image={e.imageUrl}
                            title={e.title}
                            place={e.location}
                            points={e.cost}
                            pointsWithDisscount={e.costWithDisscount}
                            textlabel={e.category.name} />
                        </Link>
                      </CarouselItem>
                    );
                  })
                }
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    );
  };

  return (
    <Container fluid className="bg-white">
      { resApi.isFetching ? <LoaderCP /> : '' }
      { resApi.error ? '' : '' }
      { resultsData && resultsData.results
        && resultsData.results.categories
        && resultsData.results.experiences
        && resApi.isFetching === false
        ? renderBody()
        : '' }
    </Container>
  );
};

export default FilterExperiencesContainer;
